import { useCallback, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

export const useTokenRefresh = () => {
  const { instance } = useMsal();

  const refreshToken = useCallback(async () => {
    const currentAccount = instance.getActiveAccount();
    if (!currentAccount) {
      return false;
    }
    
    try {
      const tokenRequest = {
        scopes: [process.env.REACT_APP_API_SCOPE!],
        account: currentAccount,
      };
      
      await instance.acquireTokenSilent(tokenRequest);
      return true;
    } catch (error: unknown) {
      console.error("Token refresh failed:", error);
      const message = (error as any)?.message as string | undefined;
      const errorCode = (error as any)?.errorCode as string | undefined;

      if (
        error instanceof InteractionRequiredAuthError ||
        errorCode === "invalid_request" ||
        message?.includes("AADSTS90009")
      ) {
        try {
          await instance.acquireTokenRedirect({
            scopes: [process.env.REACT_APP_API_SCOPE!],
            account: currentAccount,
          });
        } catch (redirectError) {
          console.error("Redirect failed, logging out:", redirectError);
          await instance.logoutRedirect();
        }
      }
      return false;
    }
  }, [instance]);

  useEffect(() => {
    const initialTimeout = setTimeout(refreshToken, 2000);
    const tokenRefreshInterval = setInterval(refreshToken, 5 * 60 * 1000);
    
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(tokenRefreshInterval);
    };
  }, [refreshToken]);

  return refreshToken;
}; 